module.exports = __webpack_public_path__ + "static/media/bg-shopping.1e54fb20.png";